import { useQuery } from "@tanstack/react-query";

import { callAvosApi } from "../utils/useAvosApiHook";
import { LocationPrediction } from "./useFacilityLocationQueries";

export const useLayerPredictions = (tenantId: string | undefined, layerId: string | undefined, enabled = true) => useQuery({
    queryKey: ["layerPredictions", tenantId, layerId],
    queryFn: async (): Promise<LocationPrediction[]> => {
        const { data } = await callAvosApi(`/${tenantId}/layers/${layerId}/predictions`);
        return data;
    },
    enabled: !!tenantId && !!layerId && enabled,
});


